module.exports = __webpack_public_path__ + "img/places-2.b65fc935.jpg";